if (!customElements.get('product-addon-picker')) {
  customElements.define('product-addon-picker', class ProductAddonPicker extends HTMLElement {
    constructor() {
      super();

      this.primarySelect = this.querySelector('.addon-select-primary');
      this.variantWrapper = this.querySelector('.addon-variant-select-wrapper');
      this.variantSelect = this.querySelector('.addon-select-variant');
      this.variantLabel = this.variantWrapper ? this.variantWrapper.querySelector('.form__label') : null;
      this.hiddenInput = this.querySelector('[name="addon_variant_id"]');
      this.infoPanel = this.querySelector('.addon-info');
      this.infoImage = this.querySelector('.addon-info__image');
      this.infoTitle = this.querySelector('.addon-info__title');
      this.infoPrice = this.querySelector('.addon-info__price');
      this.customizationWrapper = this.querySelector('.addon-customization-wrapper');
      this.customizationInput = this.querySelector('.addon-customization-text');
      this.showImage = this.dataset.showImage === 'true';
      this.showPrice = this.dataset.showPrice === 'true';

      this.addonProducts = [];
      try {
        var jsonScript = this.querySelector('.addon-products-json');
        if (jsonScript) {
          this.addonProducts = JSON.parse(jsonScript.textContent);
        }
      } catch (e) {
        console.error('Failed to parse addon products JSON', e);
      }

      if (this.primarySelect) {
        this.primarySelect.addEventListener('change', this.onAddonChange.bind(this));
      }
      if (this.variantSelect) {
        this.variantSelect.addEventListener('change', this.onVariantChange.bind(this));
      }
    }

    getProductByHandle(handle) {
      return this.addonProducts.find(function(p) { return p.handle === handle; });
    }

    onAddonChange() {
      var handle = this.primarySelect.value;

      if (!handle) {
        this.hideVariantSelect();
        this.hideInfoPanel();
        this.hideCustomization();
        this.clearSelection();
        this.toggleDynamicCheckout(true);
        return;
      }

      var product = this.getProductByHandle(handle);
      if (!product) return;

      this.toggleDynamicCheckout(false);
      this.showCustomization();

      if (product.has_only_default_variant) {
        this.hideVariantSelect();
        this.setSelectedVariant(product.variants[0]);
      } else {
        this.populateVariantSelect(product);
        this.showVariantSelect();
        this.setSelectedVariant(product.variants[0]);
      }

      this.updateInfoPanel(product, product.variants[0]);
    }

    onVariantChange() {
      var handle = this.primarySelect.value;
      var product = this.getProductByHandle(handle);
      if (!product) return;

      var variantId = parseInt(this.variantSelect.value);
      var variant = product.variants.find(function(v) { return v.id === variantId; });
      if (variant) {
        this.setSelectedVariant(variant);
        this.updateInfoPanel(product, variant);
      }
    }

    populateVariantSelect(product) {
      this.variantSelect.innerHTML = '';
      var showPrice = this.showPrice;
      product.variants.forEach(function(variant) {
        if (!variant.available) return;
        var option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.title;
        if (showPrice) {
          option.textContent += ' - ' + convertToMoney(variant.price);
        }
        this.variantSelect.appendChild(option);
      }.bind(this));

      if (product.options && product.options.length > 0) {
        this.variantLabel.textContent = product.options[0];
      } else {
        this.variantLabel.textContent = 'Option';
      }
    }

    showVariantSelect() {
      if (this.variantWrapper) {
        this.variantWrapper.style.display = '';
      }
    }

    hideVariantSelect() {
      if (this.variantWrapper) {
        this.variantWrapper.style.display = 'none';
      }
    }

    setSelectedVariant(variant) {
      if (this.hiddenInput && variant) {
        this.hiddenInput.value = variant.id;
      }
    }

    clearSelection() {
      if (this.hiddenInput) {
        this.hiddenInput.value = '';
      }
    }

    updateInfoPanel(product, variant) {
      if (!this.infoPanel) return;

      var hasContent = false;

      if (this.showImage && product.featured_image) {
        this.infoImage.src = product.featured_image;
        this.infoImage.alt = product.title;
        this.infoImage.style.display = '';
        hasContent = true;
      } else {
        this.infoImage.style.display = 'none';
      }

      if (this.infoTitle) {
        this.infoTitle.textContent = product.title;
        hasContent = true;
      }

      if (this.showPrice && variant) {
        this.infoPrice.textContent = convertToMoney(variant.price);
        this.infoPrice.style.display = '';
        hasContent = true;
      } else {
        this.infoPrice.style.display = 'none';
      }

      this.infoPanel.style.display = hasContent ? '' : 'none';
    }

    hideInfoPanel() {
      if (this.infoPanel) {
        this.infoPanel.style.display = 'none';
      }
    }

    getSelectedAddonVariantId() {
      if (this.hiddenInput && this.hiddenInput.value) {
        return this.hiddenInput.value;
      }
      return null;
    }

    toggleDynamicCheckout(show) {
      var dynamicBtn = document.querySelector('.shopify-payment-button');
      if (dynamicBtn) {
        dynamicBtn.style.display = show ? '' : 'none';
      }
    }

    showCustomization() {
      if (this.customizationWrapper) {
        this.customizationWrapper.style.display = '';
        this.customizationInput.disabled = false;
      }
    }

    hideCustomization() {
      if (this.customizationWrapper) {
        this.customizationWrapper.style.display = 'none';
        this.customizationInput.disabled = true;
        this.customizationInput.value = '';
      }
    }

    getCustomizationText() {
      if (this.customizationInput && this.customizationInput.value.trim()) {
        return this.customizationInput.value.trim();
      }
      return null;
    }
  });
}
